/**
 * Created by Ning Jiang on 2024-03-13.
 */

import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite, TweenLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {ElGordosRevengeReelView} from "../../reels/ElGordosRevengeReelView";
import {ElGordosRevengeLayers, Layers} from "../../view/ElGordosRevengeLayers";
import {ICylinderFeature} from "../../server/data/IElGordosRevengeData";
import {CylinderFeatureName} from "../../server/CylinderFeatureName";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ElGordosRevengeSymbol} from "../../symbol/ElGordosRevengeSymbol";
import {EGRStackedWild} from "../../symbol/EGRStackedWild";
import {EGRS2Symbol} from "../../symbol/EGRS2Symbol";
import {ElGordosRevengeBackground} from "../../view/ElGordosRevengeBackground";
import {ElGordosRevengeSound} from "../../sound/ElGordosRevengeSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class Cylinder extends PIXI.Container {

    private _logoLandscapeAnchor = {
        "XSPLIT" : new PIXI.Point(0, 0),
        "IN_XSPLIT" : new PIXI.Point(0, 0),
        "TURN_WILD" : new PIXI.Point(0, 0),
        "IN_WILD" : new PIXI.Point(0, 0),
        "MID_EXPAND" : new PIXI.Point(0, 0),
        "MID_MULTI" : new PIXI.Point(0, 0),
        "ADD_MULTI" : new PIXI.Point(0, 0),
        "UPDATE_FS_LEVEL" : new PIXI.Point(0, 0)
    };
    private _logoPortraitAnchor = {
        "XSPLIT" : new PIXI.Point(-30, 0),
        "IN_XSPLIT" : new PIXI.Point(-30, 0),
        "TURN_WILD" : new PIXI.Point(-60, 0),
        "IN_WILD" : new PIXI.Point(-80, 0),
        "MID_EXPAND" : new PIXI.Point(-60, 0),
        "MID_MULTI" : new PIXI.Point(-70, 0),
        "ADD_MULTI" : new PIXI.Point(-70, 0),
        "UPDATE_FS_LEVEL" : new PIXI.Point(-80, 0)
    };

    private _spine:PIXI.spine.Spine;
    private _above:PIXI.spine.Spine;
    private _under:PIXI.spine.Spine;
    private _logos:PIXI.spine.Spine;

    constructor() {
        super();

        this._under = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("cylinderVFX"));
        this._under.autoUpdate = true;
        this.addChild(this._under);

        this._spine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("cylinder"));
        this._spine.autoUpdate = true;
        this.addChild(this._spine);

        this._above = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("cylinderVFX"));
        this._above.autoUpdate = true;
        this.addChild(this._above);
    }

    public load(value:number):TimelineLite {
        const tl = new TimelineLite();
        const aniName = `C_${value}xLand`;
        tl.add(() => {
            this._spine.state.setAnimation(0, aniName, false);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.CYLINDER_LAND});
        });
        tl.add(() => {}, this._spine.spineData.findAnimation(aniName).duration + 0.4);
        return tl;
    }

    public async shoot(noWin:boolean):Promise<void> {
        noWin = false; // TODO
        const startTl = new TimelineLite();
        if(noWin) {
            // DeadwoodRip.model.parsedGameData.bulletDataList.forEach((b, i) => {
            //     const targetSymbol = DeadwoodRip.reels[b.reel].getSymbol(b.row);
            //     tl.add(targetSymbol.cylinderSplit(b.reel, b.row), 0);
            // });
            // tl.add(() => {
            //     this._spine.state.setAnimation(0, "end", false);
            //     DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.QUICK_DRAW_NO_WIN});
            // }, 0);
            // tl.add(() => {
            //     // this._spine.tint = 0x7F7777;
            // }, this._spine.spineData.findAnimation("end").duration);
            await Promise.resolve();
        } else {
            let bulletNum = ElGordosRevenge.model.parsedGameData.cylinderContent.length;
            let startAniName = `C_${bulletNum}xStart`;
            startTl.add(() => {
                this._spine.state.setAnimation(0, startAniName, false);
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.CYLINDER_ACTIVATE});
            });
            startTl.add(() => {}, this._spine.spineData.findAnimation(startAniName).duration);
            await Promise.resolve(startTl);

            await new Promise<any>(resolve => {
                this.playShootBullet(bulletNum, 0, resolve);
            });
        }
    }

    private playShootBullet(bulletNum:number, contentIndex:number, resolve:(value:any) => void) {
        if(bulletNum <= 0) {
            resolve(this);
            return;
        }
        const cf = ElGordosRevenge.model.parsedGameData.cylinderContent[contentIndex];
        const aniName = `C${bulletNum}`;
        // const targetSymbol = ElGordosRevenge.reels[cf.reel].getSymbol(cf.row);
        const bulletTl = new TimelineLite();
        bulletTl.add(() => {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.CYLINDER_FIRE});
            this._spine.state.setAnimation(0, aniName, false);
            const aboveEntry = this._above.state.setAnimation(0, "A_above", false);
            const underEntry = this._under.state.setAnimation(0, "A_underNeath", false);
            if(contentIndex > 0) {
                aboveEntry.trackTime = 0.387;
                underEntry.trackTime = 0.387;
            }
        });
        bulletTl.add(() => {
            if(bulletNum === 1) {
                this._spine.state.setAnimation(0, "end", false);
            } else {
                // const endName = `C_${bulletNum - 1}xStart`;
                // this._spine.state.setAnimation(0, endName, false).trackTime = this._spine.spineData.findAnimation(endName).duration;
            }
        }, this._spine.spineData.findAnimation(aniName).duration);
        if(bulletNum === 1) {
            bulletTl.add(() => {
                this._spine.visible = false;
            }, `+=${this._spine.spineData.findAnimation("end").duration}`)
        }
        bulletTl.add([
            this.getFeatureTl(cf),
            // targetSymbol.shotAtRandomPosition(true, false),
            // targetSymbol.cylinderSplit(cf.reel, cf.row),
            () => {
                ElGordosRevengeBackground.shakeStageOnce(0.5);
                ElGordosRevengeSound.playCylinderHitSound();
            }
        ], 0.05);
        const logoTl = new TimelineLite({paused : true});
        if(!this._logos) {
            this._logos = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("cylinderLogos"));
            this._logos.autoUpdate = true;
        }
        logoTl.add([
            () => {
                this.addChild(this._logos);
                const position = (<any>(NolimitApplication.isLandscape ? this._logoLandscapeAnchor : this._logoPortraitAnchor))[`${cf.feature}`] as PIXI.Point;
                this._logos.position.set(position.x, position.y);
                this._logos.state.setAnimation(0, cf.feature, false);
                ElGordosRevengeSound.soundPlayer.playTrack({name : (<any>ElGordosRevengeSound)[`CYLINDER_FEATURE_${cf.feature}`]});
            }
        ]);
        logoTl.add(() => {
            // this._logos.state.setEmptyAnimations(0);
        }, this._logos.spineData.findAnimation(cf.feature).duration);
        const shootTl = new TimelineLite();
        shootTl.add([
            bulletTl,
            () => {
                logoTl.play();
            }
        ]);
        shootTl.add(() => {this.playShootBullet(bulletNum - 1, contentIndex + 1, resolve)});
    }

    private getFeatureTl(cf:ICylinderFeature):TimelineLite {
        const tl = new TimelineLite();
        switch(cf.feature) {
            case CylinderFeatureName.UPDATE_FS_LEVEL:
                tl.add(ElGordosRevenge.fsMeter.updateFsLevel());
                return tl;
            case CylinderFeatureName.MID_MULTI:
                tl.add(this.playMidMulti(cf.multiplierMidInfo!));
                return tl;
            case CylinderFeatureName.MID_EXPAND:
                tl.add(this.playMidExpand(cf.expendMidCoord!));
                return tl;
            case CylinderFeatureName.ADD_MULTI:
                if(!cf.addMultipliers) {
                    debugger;
                    Logger.logDev(`Cylinder.getFeatureTl():${cf.feature} missing addMultipliers`);
                }
                tl.add(ElGordosRevenge.fsMeter.addCylinderMultipliers(cf.addMultipliers!));
                return tl;
            default:
                if(!cf.affectedArea) {
                    debugger;
                    Logger.logDev(`Cylinder.getFeatureTl():${cf.feature} missing affectedArea`);
                }
                cf.affectedArea!.forEach((reelData, reelId) => {
                    reelData.forEach((symState, symId) => {
                        if(symState) {
                            if(ElGordosRevenge.model.parsedGameData.evaluatedArea[reelId][0] === "WXN" && symId > 0) {
                                return;
                            }
                            const targetSymbol = ElGordosRevenge.reels[reelId].getSymbol(symId);
                            tl.add([
                                targetSymbol.shotAtRandomPosition(true, false),
                                targetSymbol.playCylinderFeature(reelId, symId, cf.feature),
                            ], 0);
                        }
                    });
                });
                return tl;
        }
    }

    private playMidMulti(info:{ multiplierMid:string, midMultiplier:number }):TimelineLite {
        const tl = new TimelineLite();
        for(let reelId = 0; reelId < 5; reelId++) {
            for(let symId = 0; symId < 3; symId++) {
                const sym = ElGordosRevenge.reels[reelId].getSymbol(symId);
                if(sym.symbolName.includes(info.multiplierMid) && !sym.isWild) {
                    tl.add([
                        sym.showMultiplier(info.midMultiplier, true),
                        sym.shotAtRandomPosition(true, false),
                    ], 0);
                }
            }
        }
        return tl;
    }

    private playMidExpand(coord:{ x:number, y:number }):TimelineLite {
        const tl = new TimelineLite();
        const aniName = `MidExpand_${(3 - coord.y)}`;
        const sym = ElGordosRevenge.reels[coord.x].getSymbol(coord.y);
        const spine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("midExpend"));
        spine.autoUpdate = true;
        spine.position.set(ElGordosRevengeReelView.REEL_AREAS[coord.x].x, ElGordosRevengeReelView.REEL_AREAS[coord.x].y + ElGordosRevengeSymbol.DEFAULT_HEIGHT * (coord.y + 0.5));
        tl.add(() => {
            ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(spine);
            spine.state.setAnimation(0, aniName, false);
            sym.shotAtRandomPosition(true, false);
        });
        tl.add(() => {
            ElGordosRevenge.reels[coord.x].replaceSymbolToWXN(coord.y);
        }, 0.5); // TODO: adjust time
        tl.add(() => {
            spine.state.setEmptyAnimations(0);
            spine.parent.removeChild(spine);
            spine.destroy();
        }, spine.spineData.findAnimation(aniName).duration);
        tl.add([
            () => {
                (<EGRStackedWild>ElGordosRevenge.reels[coord.x].getSymbol(coord.y)).showMultiplier(1, true);
                ElGordosRevenge.multiplier.updateReelMultiplier(coord.x, 1, true);
            },
            TweenLite.to(this, 0.6, {})
        ]);

        const nudgeSteps = -coord.y;
        if(nudgeSteps == 0) {
            return tl;
        }

        // tl.add(TweenLite.to(this, 0.2, {}));
        tl.add(ElGordosRevenge.reels[coord.x].nudge(
            nudgeSteps,
            0.25,
            `elastic.out(1, 1)`,
            0.2,
            (stepsLeft:number, aborted:boolean) => {

                if(Math.abs(stepsLeft) === 1) {
                    ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.NUDGE_STEP_FINAL[coord.x - 1]});
                } else if(!aborted) {
                    ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.NUDGE_STEP});
                }

                const symId = stepsLeft > 0 ? 0 : 2;
                const w = <EGRStackedWild>ElGordosRevenge.reels[coord.x].getSymbol(symId);
                if(!w.stack) {
                    throw new Error(`cylinder nudge error on reelId ${coord.x}, symId:${symId}, stepsLeft:${stepsLeft}, aborted:${aborted}`);
                }
                const targetMultiplier = w.currentMultiplier + 1;
                const tl = new TimelineLite();
                tl.add([
                    w.showMultiplier(targetMultiplier, true),
                    w.getNudgeAnimation(Math.abs(stepsLeft) === 1, aborted, true),
                    () => {
                        ElGordosRevenge.multiplier.updateReelMultiplier(coord.x, targetMultiplier, true);
                    }
                ]);
                // TODO: check tl end.
            },
            (stepsLeft:number, aborted:boolean) => {},
            (aborted:boolean) => {},
            false
        ));

        tl.add(TweenLite.to(this, 0.5, {}));

        return tl;
    }

    public async empty():Promise<void> {
        const emptyTl = new TimelineLite();
        emptyTl.add(() => {
            this._spine.state.setAnimation(0, "end", false);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.CYLINDER_NO_WIN});
        }, 0.3);
        emptyTl.add(() => {
            this._spine.visible = false;
        }, this._spine.spineData.findAnimation("end").duration + 0.2);
        await Promise.resolve(emptyTl);
    }
}

export class CylinderController extends WinPresentationController {

    private _cylinder:Cylinder;

    constructor() {
        super("CylinderController", false);

        // restore featured symbols.
        if(ElGordosRevenge.model.isRestore && ElGordosRevenge.model.parsedInitData.cylinderContent?.length > 0) {
            ElGordosRevenge.model.parsedInitData.cylinderContent.forEach(cf => {
                switch(cf.feature) {
                    case CylinderFeatureName.UPDATE_FS_LEVEL:
                    case CylinderFeatureName.ADD_MULTI:
                        return;
                    case CylinderFeatureName.MID_EXPAND:
                        this.restoreMidExpand(cf.expendMidCoord!);
                        return;
                    case CylinderFeatureName.MID_MULTI:
                        this.restoreMidMulti(cf.multiplierMidInfo!);
                        return;
                    default:
                        cf.affectedArea!.forEach((reelData, reelId) => {
                            reelData.forEach((symState, symId) => {
                                if(symState) {
                                    if(ElGordosRevenge.model.parsedInitData.evaluatedArea[reelId][0] === "WXN" && symId > 0) {
                                        return;
                                    }
                                    const targetSymbol = ElGordosRevenge.reels[reelId].getSymbol(symId);
                                    targetSymbol.restoreCylinderFeature(reelId, symId, cf.feature);
                                }
                            });
                        });
                }
            });
        }
    }

    private restoreMidExpand(coord:{ x:number, y:number }):void {
        // fixed in data parsing.
        return;
    }

    private restoreMidMulti(info:{ multiplierMid:string, midMultiplier:number }):void {
        for(let reelId = 0; reelId < 5; reelId++) {
            for(let symId = 0; symId < 3; symId++) {
                const sym = ElGordosRevenge.reels[reelId].getSymbol(symId);
                if(sym.symbolName.includes(info.multiplierMid)) {
                    sym.showMultiplier(info.midMultiplier, false);
                }
            }
        }
    }

    protected hasWin():boolean {
        const model = ElGordosRevenge.model;
        const featureBuySFS = (model.buyFeatureName?.includes("LUCKY_DRAW") || model.buyFeatureName?.includes("FREESPIN_SUPER")) && model.parsedGameData.mode === GameMode.NORMAL;
        return model.parsedGameData.showCylinder && !featureBuySFS;
    }

    protected async createWinAnimation():Promise<void> {
        ElGordosRevenge.playScattersWin = true;
        if(ElGordosRevenge.model.parsedGameData.mode != GameMode.FREESPIN_SUPER) {
            await this.load();
        }
        if(ElGordosRevenge.model.parsedGameData.cylinderContent.length > 0) {
            await this._cylinder.shoot(ElGordosRevenge.model.parsedGameData.mode === GameMode.NORMAL && ElGordosRevenge.model.parsedGameData.singleWin == 0);
        } else {
            await this._cylinder.empty();
        }
        this.reset();
    }

    public load():TimelineLite {
        const position = ElGordosRevengeReelView.getSymbolGlobalPosition(5, 0);
        this._cylinder = new Cylinder();
        this._cylinder.position.set(position.x, position.y + ElGordosRevengeSymbol.DEFAULT_HEIGHT * 0.5);
        const s2 = <EGRS2Symbol>ElGordosRevenge.reels[5].getSymbol(0);
        const tl = new TimelineLite();
        tl.add(() => s2.playCylinderStart());
        tl.add([
            () => {
                ElGordosRevengeLayers.getLayer(Layers.CYLINDER)?.addChild(this._cylinder);
            },
            this._cylinder.load(ElGordosRevenge.model.parsedGameData.cylinderContent.length)
        ], 0.4);
        return tl;
    }

    public reset():void {
        if(this._cylinder) {
            if(this._cylinder.parent) {
                this._cylinder.parent.removeChild(this._cylinder);
            }
            this._cylinder.destroy();
        }
    }
}